// Set format for results
const setFormatNumber = (dataFormat) => +Math.round(dataFormat);

// PMI rate -- (PMI-Ипотечное страхование)
const getPmiResult = (excludeValue, mortgageAmount, pmiRate, switchPMI) => {
  if (!excludeValue) {
    if (switchPMI === '%') {
      const result = (mortgageAmount * (pmiRate / 100)) / 12;
      return setFormatNumber(result);
    }

    const result = pmiRate / 12;
    return setFormatNumber(result);
  }

  return 0;
};

// Property tax function
const propertyTaxCalc = (excludeValue, propertyTax, switchTaxes, homePrice) => {
  if (!excludeValue) {
    if (switchTaxes === '$') {
      const result = setFormatNumber(propertyTax / 12);
      return setFormatNumber(result);
    }

    const result = ((propertyTax / 100) * homePrice) / 12;
    return setFormatNumber(result);
  }

  return 0;
};
// Down Payment
const getDownPaymentResult = (downPayment, homePrice, switchDownPayment) => {
  if (switchDownPayment === '$') {
    return setFormatNumber(downPayment);
  }

  const result = ((downPayment / 100) * homePrice);
  return setFormatNumber(result);
};
// Mortgage amount
const getMortgageAmountResult = (homePrice, downPaymentResult) => {
    const result = homePrice - downPaymentResult; // основной кредит, основная сумма
    if(result > 0) {
      return setFormatNumber(result);
    }
    return 'Data incorrect'
};

// Home insurance function
const homeInsuranceCalc = (excludeValue, homeInsurance, switchHomeInsurance, homePrice) => {
  if (!excludeValue) {
    if (switchHomeInsurance === '$') {
      return setFormatNumber(homeInsurance / 12);
    }

    const result = (( homeInsurance / 100 ) * homePrice) / 12;
    return setFormatNumber(result);
  }

  return 0;
};

// Home owners insurance function
// const homeownersInsuranceCalc = (excludeValue, homeownersInsurance, switchHomeownersInsurance, homePrice) => {
//   if (!excludeValue) {
//     if (switchHomeownersInsurance === '$') {
//       return setFormatNumber(homeownersInsurance / 12);
//     }
//
//     const result = ((homeownersInsurance / 100) * homePrice) / 12;
//     return setFormatNumber(result);
//   }
//
//   return 0;
// };

// Monthly function
const monthlyPaymentCalc = (
  mortgageAmount,
  interestRateResult,
  paymentsMonths,
  pmiResult,
  hoaAmount,
  propertyTaxResult,
  homeInsuranceResult,
  // homeownersInsuranceResult
) => {
  if (interestRateResult !== 0) {
    const result =
      (mortgageAmount * interestRateResult * (1 + interestRateResult) ** paymentsMonths) /
        ((1 + interestRateResult) ** paymentsMonths - 1) +
      pmiResult +
      hoaAmount +
      propertyTaxResult +
      homeInsuranceResult;
      // homeownersInsuranceResult;
    if(result > 0) {
      return setFormatNumber(result);
    }
    return 'Data incorrect'
  }

  return 0;
};

// Monthly PI function
const monthlyPICalc = (mortgageAmount, interestRateResult, paymentsMonths) => {
  const result =
    (mortgageAmount * interestRateResult * (1 + interestRateResult) ** paymentsMonths) /
    ((1 + interestRateResult) ** paymentsMonths - 1);

  return setFormatNumber(result);
};

// Total cost function
// OLD
// const totalCostAmountCalc = (monthlyPaymentResult, paymentsMonths) => {
//   const result = monthlyPaymentResult * paymentsMonths;
//
//   if(result > 0) {
//     return setFormatNumber(result);
//   }
//   return 'Data incorrect'
// };
const totalCostAmountCalc = (monthlyPIResult, paymentsMonths) => {
  const result = monthlyPIResult * paymentsMonths;

  if(result > 0) {
    return setFormatNumber(result);
  }
  return 'Data incorrect'
};

const calc = (elements, watchedState) => {
  const { form, result, donutData } = watchedState;
  const { values, exclude, switches } = form;

  const homePrice = values['home-price'];
  const downPayment = values['down-payment'];
  const interestRate = values['interest-rate'];
  const homeInsurance = values['home-insurance'];
  const homeownersInsurance = values['additional-insurance'];
  const propertyTax = values['property-tax'];
  const pmiRate = values['pmi-rate'];
  const hoaAmount = values['hoa-dues'];
  const { term } = values;
  const monthInYear = 12;
  const percentBase = 100;

  // * switchers
  const switchTaxes = switches['switch-property'];
  const switchDownPayment = switches['switch-down-payment'];
  const switchHomeInsurance = switches['switch-home-insurance'];
  const switchPMI = switches['switch-mortgage'];
  // const switchInsurance = exclude['switch-insurance'];

  const downPaymentResult = getDownPaymentResult(downPayment, homePrice, switchDownPayment);
  const mortgageAmount = getMortgageAmountResult(homePrice, downPaymentResult);
  const paymentsMonths = term * monthInYear; // количество месяцев
  const interestRateResult = interestRate / percentBase / monthInYear; // процентная ставка по еж.платежу

  const pmiResult = getPmiResult(exclude['property-tax'], mortgageAmount, pmiRate, switchPMI, homePrice);

  // const homeownersInsuranceResult = homeownersInsuranceCalc(exclude['additional-insurance'], homeownersInsurance, switchHomeownersInsurance, homePrice);
  const homeInsuranceResult = homeInsuranceCalc(exclude['property-tax'], homeInsurance, switchHomeInsurance, homePrice);

  const propertyTaxResult = propertyTaxCalc(exclude['property-tax'], propertyTax, switchTaxes, homePrice);

  const monthlyPaymentResult = monthlyPaymentCalc(
    mortgageAmount,
    interestRateResult,
    paymentsMonths,
    pmiResult,
    hoaAmount,
    propertyTaxResult,
    homeInsuranceResult,
    // homeownersInsuranceResult,
  );
  const monthlyPIResult = monthlyPICalc(mortgageAmount, interestRateResult, paymentsMonths);

  // old
  // const totalCostAmountResult = totalCostAmountCalc(monthlyPaymentResult, paymentsMonths);
  const totalCostAmountResult = totalCostAmountCalc(monthlyPIResult, paymentsMonths);

  // * RESULTS
  // calcMortgageAmount - сумма ипотеки
  result['mortgage-amount'] = mortgageAmount;
  // calcMonthlyPayment - ежемесячный платеж
  result['monthly-payment'] = monthlyPaymentResult;
  // calcTotalCost - общая сумма выплат
  result['mortgage-insurance'] = pmiResult;
  // Total Cost Of Mortgage
  result['mortgage-total-cost'] = totalCostAmountResult;
  // donut data list
  donutData.forEach(({ key }, index) => {
    switch (key) {
      case 'pi':
        donutData[index].data = monthlyPIResult;
        break;
      case 'insurance':
        donutData[index].data = homeInsuranceResult; // + homeownersInsuranceResult
        break;
      case 'taxes':
        donutData[index].data = propertyTaxResult;
        break;
      case 'pmi':
        donutData[index].data = pmiResult;
        break;
      case 'hoa':
        donutData[index].data = hoaAmount;
        break;

      default:
        break;
    }
  });
};

export default calc;
